import { get, patch, post, remove } from '@/api/base'

const weighStationsApi = {
  getAll: async params => {
    const response = await get({
      path: 'weigh_stations',
      params,
    })
    return response.success
      ? {
          ...response,
          weighStations: response.data.weigh_stations,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  get: async stationUuid => {
    const response = await get({
      path: `weigh_stations/${stationUuid}`,
    })
    return response.success ? response.data.weigh_station : {}
  },
  update: async (stationUuid, params) => {
    const response = await patch({
      path: `weigh_stations/${stationUuid}`,
      params,
    })
    return response.success ? response.data.weigh_station : null
  },
  delete: async stationUuid => {
    return await remove({
      path: `weigh_stations/${stationUuid}`,
    })
  },
  create: async params => {
    const response = await post({
      path: 'weigh_stations',
      params,
    })
    return response.success ? response.data.weigh_station : null
  },
}

export default weighStationsApi
